import type { Configuration } from '@azure/msal-browser';
import { LogLevel } from '@azure/msal-browser';

/**
 * Azure AD B2C Configuration for Chelless Admin Site
 *
 * Tenant: Chelless.onmicrosoft.com
 * App registration: chelless-admin-spa (requires 'Admin' role claim)
 *
 * All sensitive values are read from VITE_* environment variables.
 * Never hard-code client IDs or secrets here.
 */

// B2C Policies/User Flows — same tenant as the user app
export const b2cPolicies = {
  names: {
    signUpSignIn: 'B2C_1_SignUpSignIn',
  },
  authorities: {
    signUpSignIn: {
      authority:
        import.meta.env.VITE_MSAL_AUTHORITY || 'PLACEHOLDER_ADMIN_AUTHORITY',
    },
  },
  authorityDomain:
    (import.meta.env.VITE_MSAL_KNOWN_AUTHORITIES || 'PLACEHOLDER_ADMIN_KNOWN_AUTHORITIES')
      .split(',')[0]
      .trim(),
};

// MSAL Configuration — mirrors user app shape, different client ID + scopes
export const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_MSAL_CLIENT_ID || 'PLACEHOLDER_ADMIN_CLIENT_ID',
    authority: b2cPolicies.authorities.signUpSignIn.authority,
    knownAuthorities: (
      import.meta.env.VITE_MSAL_KNOWN_AUTHORITIES || 'PLACEHOLDER_ADMIN_KNOWN_AUTHORITIES'
    )
      .split(',')
      .map((s: string) => s.trim()),
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
    navigateToLoginRequestUrl: true,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          case LogLevel.Info:
            console.info(message);
            break;
          case LogLevel.Verbose:
            console.debug(message);
            break;
        }
      },
      logLevel: LogLevel.Warning,
    },
  },
};

// Login request — admin site requests openid/profile only; API scope is separate
export const loginRequest = {
  scopes: ['openid', 'profile', 'offline_access'],
};

// API scope for the admin backend (scope exposed by ChellessAPI app registration)
// The 'Admin' role claim is issued by B2C based on app role assignment, not as a scope.
export const adminApiScopes = [
  'https://Chelless.onmicrosoft.com/ChellessAPI/Read',
  'https://Chelless.onmicrosoft.com/ChellessAPI/Write',
];
